import React, {  useRef } from "react";
import { Footer } from "./Footer";
import Brands from "./Brands";
import { FaFacebookF } from 'react-icons/fa';
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import { Col, Container, Row, Button } from "react-bootstrap";
import black_about from "../Assets/videos/black-1.mp4";
import type1 from "../Assets/img/pipe1.jpg";
import type2 from "../Assets/img/pipe2.jpg";
import type3 from "../Assets/img/pipe3.jpg";
import GoTop from "./GoTop";
import bgImage from "../Assets/img/bgs/15.jpeg";
// import { Link } from "react-router-dom";

import black from "../Assets/img/blackPipe.png";
import Navigation from "./Navigation";

const BlackPipe = ({ lang: currentLanguage }) => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_inyaa89",
        "template_993qouc",
        form.current,
        "user_DfrMcD1i8Klde4wR1m0qR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();

  };
    const { t } = useTranslation();

 
  const aboutTextClass = () => {
    switch (currentLanguage.code) {
      case 'en':
        return 'about-text-en';
      case 'ar':
        return 'about-text-ar';
      case 'kur':
        return 'about-text-kur';
      default:
        return ''; // Fallback class
    }
  };
  
  const menu = ["about", "blackPipe"];
 return (
    <>
      <Navigation navs={menu} />
      <div id="bp-head" >
      
      {/* Ensure the class is b-bg-container, NOT b-bg */}
     <div className="hero-motion-container">
  {/* Layer 1: Background */}
  <img src={bgImage} className="hero-motion-bg" alt="" />
  
  {/* Layer 2: Content on top */}
  <div className="hero-motion-overlay">
    <img src={black} className="hero-motion-logo" alt="Logo" />
    <h3 style={{ color: '#000', fontWeight: '700' }}>
      {t("b_top_header1")}
    </h3>
  </div>
</div>
 </div>
    {/* Brands */}
      <Brands />
      {/* ABOUT */}
            <div id="about" className="s-about" data-aos="fade-up" data-aos-duration="1000">
        <div className="s-about-inner">
                <Container>
                  <Row>
                    <Col
                        md={6}
                        className="left d-flex justify-content-center align-items-cenetr"
                       >
                        <video
                        src={black_about}
                        autoPlay
                        muted
                        controls="controls"
                        loop
                        webkit-playsInline
                        playsInline
                        autofullscreen="false"
                        style={{ width: "100%", maxWidth: "600px", height: "auto" }}
                        alt=""
                       />
                    </Col>
                    <Col xs={12} md={6} className="about-us">
                                    <div className={`about-text ${aboutTextClass()}`}>
                                      <h2 className={` ${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}>
                                        {t("about_us")}
                                      </h2>
                                      <div className="mb-4">
                                        <hr className="hr" />
                                      </div>
                                      <div className={`about-text ${aboutTextClass()}`}>
                                        <p>{t("b_about_p")}</p>
                                      </div>
                                    </div>
                                  </Col>
                  </Row>
               </Container>
              </div>
            </div>
            <div className="article-text-box" data-aos="fade-up" data-aos-duration="1000">
                    <Container>
                      <div className="article">
                        
                      
                        
                        
                        {/* Product Types */}
                        <div className="s-types mb-5" data-aos="fade-in" data-aos-duration="1500">
                          <Container>
                            <Row>
  <h4
    className={`mb-1 ${
      currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
    }`}
  >
    {t("p_type")}
  </h4>
  <div className="mb-3 ">
    <hr className="s-hr" />
  </div>
  <Col sm={12} className="px-md-5">
    <div className="list-types">
      {/* Type 1 with its image */}
      <div className="type-item mb-4">
        <h5 className="mb-2">{t("b_type1")}</h5>
        <div className="text-center">
          <img src={type1} className="img-fluid" alt={t("p_type1")} />
        </div>
      </div>

      {/* Type 2 with its image */}
      <div className="type-item mb-4">
        <h5 className="mb-2">{t("b_type2")}</h5>
        <div className="text-center">
          <img src={type2} className="img-fluid" alt={t("p_type2")} />
        </div>
      </div>

      {/* Type 3 with its image */}
      <div className="type-item mb-4">
        <h5 className="mb-2">{t("b_type3")}</h5>
        <div className="text-center">
          <img src={type3} className="img-fluid" alt={t("p_type3")} />
        </div>
      </div>
    </div>
  </Col>
</Row>

                          </Container>
                        </div>
                       {/* Services1 */}
                                   <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                                     <Container>
                                       <h4
                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                       >
                                         {t("b_di1")}
                                       </h4>
                                       <div className="mb-3">
                                         <hr className="s-hr" />
                                       </div>
                                        <Row>
                                          <div className="table-responsive"> {/* Add this wrapper */}
      <table className="table table-sm text-center w-75"><thead>
          <tr className="table-primary">
            <th scope="col">{t("round")}</th>
            <th scope="col">{t("p10")}</th>
            <th scope="col">{t("p16")}</th>
            <th scope="col">{t("p18")}</th>
            <th scope="col">{t("p21")}</th>
            <th scope="col">{t("p25")}</th>
            <th scope="col">{t("p28")}</th>
            <th scope="col">{t("p32")}</th>
            <th scope="col">{t("p38")}</th>
            <th scope="col">{t("p42")}</th>
            <th scope="col">{t("p48")}</th>
            <th scope="col">{t("p57")}</th>
            <th scope="col">{t("p60")}</th>
            <th scope="col">{t("p76")}</th>
            <th scope="col">{t("p89")}</th>
            <th scope="col">{t("p101")}</th>
          </tr>
        </thead><tbody>
          <tr>
            <td>{t("r0_50")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_60")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_70")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_80")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_90")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_00")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_10")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_20")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_30")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_40")}</td>
            <td></td>
           <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_50")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_60")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_70")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_80")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_90")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_00")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_25")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_50")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_70")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r3_00")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
        </tbody></table>
      </div>
    </Row>
                                     </Container>
                                   </div>
                                    {/* Services2 */}
                                   <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                                     <Container>
                                       <h4
                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                       >
                                         {t("b_di2")}
                                       </h4>
                                       <div className="mb-3">
                                         <hr className="s-hr" />
                                       </div>
                                        <Row>
                                          <div className="table-responsive"> {/* Add this wrapper */}
      <table className="table table-sm text-center w-75"><thead>
          <tr className="table-primary">
            <th scope="col">{t("square")}</th>
            <th scope="col">{t("p15x15")}</th>
            <th scope="col">{t("p20x20")}</th>
            <th scope="col">{t("p25x25")}</th>
            <th scope="col">{t("p30x30")}</th>
            <th scope="col">{t("p40x40")}</th>
            <th scope="col">{t("p50x50")}</th>
            <th scope="col">{t("p70x70")}</th>
            <th scope="col">{t("p80x80")}</th>
          </tr>
        </thead><tbody>
          <tr>
            <td>{t("r0_50")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_60")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_70")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_80")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_90")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_00")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_10")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_20")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_30")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_40")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_50")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_60")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_70")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_80")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_90")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_00")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_25")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_50")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_70")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r3_00")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
        </tbody></table>
      </div>
    </Row>
                                     </Container>
                                   </div>
                                   {/* Services3 */}
                                   <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                                     <Container>
                                       <h4
                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                       >
                                         {t("b_di3")}
                                       </h4>
                                       <div className="mb-3">
                                         <hr className="s-hr" />
                                       </div>
                                        <Row>
                                          <div className="table-responsive"> {/* Add this wrapper */}
      <table className="table table-sm text-center w-100"><thead>
          <tr className="table-primary">
            <th scope="col">{t("rectangle")}</th>
            <th scope="col">{t("p10x20")}</th>
            <th scope="col">{t("p10x40")}</th>
            <th scope="col">{t("p20x40")}</th>
            <th scope="col">{t("p20x50")}</th>
            <th scope="col">{t("p25x50")}</th>
            <th scope="col">{t("p30x40")}</th>
            <th scope="col">{t("p30x50")}</th>
            <th scope="col">{t("p30x60")}</th>
            <th scope="col">{t("p40x60")}</th>
            <th scope="col">{t("p40x80")}</th>
            <th scope="col">{t("p50x100")}</th>
          </tr>
        </thead><tbody>
          <tr>
            <td>{t("r0_50")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_60")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_70")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_80")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_90")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_00")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_10")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r1_20")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_30")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_40")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_50")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_60")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_70")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_80")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_90")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_00")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_25")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_50")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_70")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r3_00")}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{t("check")}</td> 
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
        </tbody></table>
      </div>
    </Row>
                                     </Container>
                                   </div>
                                   {/* Services4 */}
                                   <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                                     <Container>
                                       <h4
                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                       >
                                         {t("b_di4")}
                                       </h4>
                                       <div className="mb-3">
                                         <hr className="s-hr" />
                                       </div>
                                        <Row>
      <table className="table table-sm text-center w-75"><thead>
          <tr className="table-primary">
            <th scope="col">{t("oval")}</th>
            <th scope="col">{t("p20x40t")}</th>
            <th scope="col">{t("tShape")}</th>
            <th scope="col">{t("lShape")}</th>
            <th scope="col">{t("zShape")}</th>
          </tr>
        </thead><tbody>
          <tr>
            <td>{t("r0_50")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_60")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_70")}</td>
            <td>{t("check")}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{t("r0_80")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r0_90")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_00")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_10")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_20")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_30")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_40")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_50")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_60")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_70")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_80")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r1_90")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_00")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
          <tr>
            <td>{t("r2_25")}</td>
            <td></td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
            <td>{t("check")}</td>
          </tr>
        </tbody></table>
    </Row>                        </Container>
                                   </div>
                                  
                      </div>
                    </Container>
                  </div>
      <Container className="py-5 text-center">
        <img src={black} className="w-50 mt-5" alt="" />
      </Container>
      {/* CONTACT */}
      <div id="contact">
        <div className="overlay">
          <Container>
            <Row>
              <Col lg={{ span: 6, order: 2 }} className=" contactFormCol">
                <div className="contact-us">
                  <h4
                    className={`mb-4 text-center ${
                      currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                    }`}
                  >
                    {t("contact_form")}
                  </h4>
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                      <label htmlFor="name">{t("name")} :</label>
                      <input
                        type="text"
                        className="form-control form-control-sm my-1"
                        id="name"
                        placeholder={t("name")}
                        name="name"
                        required
                      />
                    </div>
                    <div className="form-group my-3">
                      <label htmlFor="email">{t("email")} :</label>
                      <input
                        type="email"
                        className="form-control form-control-sm my-1"
                        id="email"
                        placeholder={t("email")}
                        aria-describedby="emailHelp"
                        name="email"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">{t("message")} :</label>
                      <textarea
                        className="form-control form-control-sm my-1"
                        id="message"
                        placeholder={t("message")}
                        rows="3"
                        name="message"
                        required
                      ></textarea>
                    </div>
                    <div className="d-flex flex-row">
                      <Button
                        variant="primary"
                        className="mt-3 px-3 btn-sm"
                        type="submit"
                      >
                        {t("send_message")}
                      </Button>
                    </div>
                  </form>
                </div>
              </Col>
              <Col lg={{ span: 6, order: 1 }} className="text-center px-4 py-4">
                <h3
                  className={`mb-4 ${
                    currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"
                  }`}
                >
                  {t("b_app_title")}
                </h3>
                <p className="fs-7 mb-5">
                  Black Pipe Factory produces the best pipes and steel profiles in various sizes with new and advanced lines according to Iraqi and international standards and by skilled and experienced engineers.
                </p>
                <h6>{t("address")}</h6>
                <p className="px-5">{t("b_add_value")}</p>
                <h6>{t("phone")}</h6>
                <a href="tel:+9647704456622" className="contactLinks">
                  +964_770_445_6622
                </a>{" "}
                <br />
                <a href="tel:+9647508281666" className="contactLinks">
                  +964_750_828_1666
                </a>
                 <br />
                <a href="tel:+9647704867700" className="contactLinks">
                  +964_770_486_7700
                </a>
                 <br />
                <a href="tel:+9647807331212" className="contactLinks">
                  +964_780_733_1212
                </a>
                <h6>{t("email")}</h6>
                <a href="mailto:blackpipefactory@gmail.com" className="contactLinks">
                  blackpipefactory@gmail.com
                </a>
                <br />
                                {/* Wrap this in a div to center it properly */}
                <div className="mt-3 d-flex justify-content-center">
                  <a 
                    href="https://www.facebook.com/blackpipefactory1/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="facebook-link-crisp"
                  >
                    <div className="fb-icon-circle">
                      <FaFacebookF className="fb-vector-icon" />
                    </div>
                    <span className="fb-text">Black Pipe Factory</span>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div>
        <iframe
          title="runaky-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3221.595896457583!2d43.8632007!3d36.1520514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40073d4f0bb184b3%3A0xe9d48fcf3a3e4ca1!2zQmxhY2sgUGlwZSBGYWN0b3J5INmF2LnZhdmEINio2YTYp9mDINio2KfZitio!5e0!3m2!1sen!2siq!4v1759327012899!5m2!1sen!2siq"
          width="100%"
          height="100% "
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
      <Footer />
      <GoTop id="bp-head" />
    </>
    
    
  );
};

export default BlackPipe;
